<template>
  <div class="body-right">
    <div class="title-body-right">
      <h1 class="title-page">{{ $t('store.title') }}</h1>

      <div class="group-btn">
        <el-button
          v-if="userInfo.type === ERolAdmin.ADMIN"
          class="btn"
          type="primary"
          @click="handleOpenAddDialog()"
        >
          {{ $t('store.addStoreBtn') }}
        </el-button>

        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>
      </div>
    </div>

    <div class="search-wrap">
      <div class="search-form" :class="openSearchForm ? 'open' : 'hidden'">
        <el-form
          :inline="true"
          :model="search"
          class="form"
          @submit.native.prevent
          @keyup.enter.native="onSubmitSearch"
        >
          <el-form-item>
            <el-input
              v-model="search.freeText"
              :placeholder="$t('store.searchPlaceholder')"
              class="search-input"
              maxlength="225"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="search.freeText = ''"
                v-if="search.freeText"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search-button"
              type="primary"
              @click="onSubmitSearch()"
            >
              {{ $t('store.searchBtn') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-row
        class="total-table"
        :class="openSearchForm ? 'total-table-absolute' : ''"
      >
        {{ $t('store.total') }}: {{ store.total }}
      </el-row>
    </div>

    <table-store :dataColumn="store.data" :currentPage="store.currentPage" />

    <div class="pagination">
      <base-pagination
        :totalPage="store.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.page"
      ></base-pagination>
    </div>

    <add-store-dialog
      :openAddDialog="openAddDialog"
      @handleCloseAddDialog="handleCloseAddDialog()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const BasePagination = () => import('@/components/BasePagination');
const AddStoreDialog = () => import('./AddStoreDialog');
const TableStore = () => import('./TableListStore');
import { LIMIT, PAGE } from '@/constants/common';
import { redirectRouter } from '@/helper';
import * as pageRouter from '@/constants/pageRouter';
import { ERolAdmin } from '@/enums/user';

export default {
  name: 'ListStore',
  components: {
    BasePagination,
    AddStoreDialog,
    TableStore,
  },
  data() {
    return {
      ERolAdmin,
      openAddDialog: false,
      search: {
        freeText: undefined,
        page: PAGE,
        limit: LIMIT,
      },
      formLabelWidth: '120px',
      openSearchForm: true,
    };
  },
  computed: {
    ...mapGetters('store', ['store', 'error']),
    ...mapGetters('user', ['userInfo']),
  },
  methods: {
    ...mapActions('store', ['getStoreList']),
    handleOpenAddDialog() {
      this.openAddDialog = true;
    },
    handleCloseAddDialog() {
      this.openAddDialog = false;
    },
    regexPhone(value) {
      return value.replace(/[\-]+/g, '').trim();
    },
    onSubmitSearch() {
      this.search = {
        ...this.search,
        page: PAGE,
      };

      this.getStoreList({
        ...this.search,
        freeText: this.search.freeText
          ? this.regexPhone(this.search.freeText)
          : undefined,
      });

      redirectRouter({
        path: pageRouter.STORE,
        query: {
          freeText: this.search.freeText
            ? this.search.freeText.trim()
            : undefined,
          page: this.search.page,
        },
      });
    },

    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        page: e.page,
        limit: LIMIT,
      };
      this.getStoreList({
        ...this.search,
        freeText: this.$router.currentRoute.query.freeText
          ? this.regexPhone(this.$router.currentRoute.query.freeText)
          : undefined,
      });

      redirectRouter({
        path: pageRouter.STORE,
        query: {
          ...this.$router.currentRoute.query,
          page: this.search.page || undefined,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
  },
  created() {
    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
    };

    this.getStoreList({
      ...this.search,
      freeText: this.$router.currentRoute.query.freeText
        ? this.regexPhone(this.$router.currentRoute.query.freeText)
        : undefined,
    });
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
</style>
